/**
 * events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 2.14
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */



export type EventTypeEnum = 'training_stats_scalar' | 'training_stats_vector' | 'training_debug_image' | 'plot' | 'log';

export const EventTypeEnum = {
    TrainingStatsScalar: 'training_stats_scalar' as EventTypeEnum,
    TrainingStatsVector: 'training_stats_vector' as EventTypeEnum,
    TrainingDebugImage: 'training_debug_image' as EventTypeEnum,
    Plot: 'plot' as EventTypeEnum,
    Log: 'log' as EventTypeEnum
}
